// Material Dashboard 2 PRO React TS Base Styles
import colors from '@theme/base/colors';
import borders from '@theme/base/borders';

// Material Dashboard 2 PRO React TS Helper Functions
import pxToRem from '@theme/functions/pxToRem';

const { white } = colors;
const { borderRadius } = borders;

// types
type Types = any;

const tabs: Types = {
  styleOverrides: {
    root: {
      position: 'relative',
      backgroundColor: '#fff',
      borderRadius: borderRadius.xl,
      minHeight: 'unset',
      padding: pxToRem(4)
    },

    flexContainer: {
      height: '100%',
      position: 'relative',
      zIndex: 10
    },

    fixed: {
      overflow: 'unset !important',
      overflowX: 'unset !important'
    },

    vertical: {
      '& .MuiTabs-indicator': {
        width: '100%'
      }
    },

    indicator: {
      height: '100%',
      borderRadius: borderRadius.lg,
      backgroundColor: white.main,
      transition: 'all 500ms ease'
    }
  }
};

export default tabs;
